import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-market-tabs',
  templateUrl: './market-tabs.component.html',
  styleUrls: ['./market-tabs.component.scss'],
})
export class MarketTabsComponent implements OnInit {
  title = 'app-market-tabs';

  ngOnInit(): void {}
}
